var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewConsult = function SvgNewConsult(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 29,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "newConsult_svg__a",
    width: 28,
    height: 29,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 .5h28v28H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#212121",
    mask: "url(#newConsult_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.711 16.93-1.623 2.22V6.92h16.667v2.544h1.754V6.763c0-.877-.71-1.596-1.587-1.596h-17c-.877 0-1.588.719-1.588 1.596v15.07a.877.877 0 0 0 1.588.518l2.938-4.026h2.842V16.57h-3.29a.88.88 0 0 0-.71.36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.188 21.087-1.652-1.651H11.444a.35.35 0 0 1-.258-.101.35.35 0 0 1-.101-.258v-7.718a.35.35 0 0 1 .1-.258.35.35 0 0 1 .259-.101h12.384a.35.35 0 0 1 .259.1.35.35 0 0 1 .1.259zm.699 2.75q.406 0 .729-.295.322-.296.322-.782V11.36a2.03 2.03 0 0 0-.62-1.49 2.03 2.03 0 0 0-1.49-.619H11.444a2.03 2.03 0 0 0-1.49.62 2.03 2.03 0 0 0-.619 1.489v7.718q0 .87.62 1.49.618.618 1.489.619h10.365l2.336 2.335q.164.165.35.24.188.077.392.077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.717 14.5h7.448a.85.85 0 0 0 .624-.252.85.85 0 0 0 .251-.623.85.85 0 0 0-.251-.624.85.85 0 0 0-.624-.251h-7.448a.85.85 0 0 0-.624.252.85.85 0 0 0-.251.623q0 .372.251.624a.85.85 0 0 0 .624.25M17.665 17.417h-3.948a.85.85 0 0 1-.624-.252.85.85 0 0 1-.251-.623q0-.372.251-.624a.85.85 0 0 1 .624-.251h3.948q.372 0 .624.251a.85.85 0 0 1 .251.623.85.85 0 0 1-.251.624.85.85 0 0 1-.624.252"
  }))));
};
export default SvgNewConsult;